/**
 * Created by karora on 14/2/2019
 */
export class Installation {
  uid: number;
  uploaded: Date;
  serial_no: number;
  post_code: string;
  job_id: string;
  created_on: Date;
  assigned_date_time: Date;
  first_name: string;
  last_name: string;
  address_line_1: string;
  address_line_2: string;
  address_line_3: string;
  city: string;
  job_postal_code: string;
  contact_phone: string;
  contact_mobile: string;
  contact_email: string;
  start_time: Date;
  end_time: Date;
  last_updated_date_time: Date;
  status: string;
  notes: string;
  mprn: string;
  eircode: string;
  start_job: string;
  scan_serial_number_of_hub: string;
  entered_serial_number_of_hub: string;
  gprn: string;
  process_error: string;
  assignedto: string;
  installerid: string;
  geopal_data: Object;
  date_corrected: Date;
  unique_id: number;
}

export class uploadFailure {
  failure: Installation;
  cause: any;
}
